var React = require('react');

function HalfStar (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.9 6.1c-.1-.3-.4-.6-.7-.7l-4.1-1.1L8.9 1C8.5.4 7.5.4 7.1 1L4.8 4.4l-4 1.1c-.4.1-.6.3-.7.6-.1.3 0 .7.2 1l2.6 3.2-.2 4.1c0 .3.1.7.4.9.3.2.7.3 1 .1L8 13.9l3.9 1.5c.1 0 .2.1.4.1s.4-.1.6-.2c.3-.2.4-.5.4-.9l-.2-4.1 2.6-3.2c.3-.3.4-.6.2-1","fill":"#f4f5f6","key":0}),React.createElement("path",{"d":"M8 13.9l-3.9 1.5c-.3.1-.7.1-1-.1-.3-.2-.4-.5-.4-.9l.2-4.1L.2 7.1c-.2-.3-.3-.6-.1-1 .1-.3.4-.6.7-.7l4.1-1.1L7.1 1c.2-.3.6-.5.9-.5v13.4z","fill":"#fed045","key":1})]);
}

HalfStar.defaultProps = {"width":"16","height":"16"};

module.exports = HalfStar;

HalfStar.default = HalfStar;
